import { ReactNode, PropsWithChildren } from 'react'

import { Close as CloseIcon } from 'components/Icons'
import {
  WizardBody,
  WizardCloseBtn,
  WizardFooter,
  WizardHeader,
  WizardHeaderLeftBlock,
  WizardHeaderRightBlock,
  WizardLayoutContainer,
} from './styles'

interface NetworkWizardLayoutProps {
  handleClose?: () => void
  bottomBlock?: ReactNode
  headerBlock?: ReactNode
}

function WizardLayout({
  headerBlock = null,
  bottomBlock = null,
  handleClose,
  children,
}: PropsWithChildren<NetworkWizardLayoutProps>) {
  return (
    <WizardLayoutContainer>
      <WizardHeader>
        <WizardHeaderLeftBlock>{headerBlock}</WizardHeaderLeftBlock>
        <WizardHeaderRightBlock>
          <WizardCloseBtn onClick={handleClose}>
            <CloseIcon />
          </WizardCloseBtn>
        </WizardHeaderRightBlock>
      </WizardHeader>

      <WizardBody>{children}</WizardBody>
      <WizardFooter>{bottomBlock}</WizardFooter>
    </WizardLayoutContainer>
  )
}

export default WizardLayout
